/**
 * @desc 查询单个产品信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.ProductMasterResponseDto>;
export function request(sku: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productSku/byUnique/${sku}`, {
      method: "GET",

      ...options,
    }),
  );
}
